export default "__VITE_ASSET__9ed3307a__"